module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 33 64",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#facebook",
      toString: function () {
        return this.url;
      }
    }